import React from 'react'
import { Box } from '@mui/material'
import { Drawer, Loader } from 'packages/eid-ui'
import ItemHeader from '../../ItemHeader'
import { isNilOrEmpty, useIsSmallScreen } from 'packages/core'
import { useAzureRole, useTargetPerson } from 'hooks'
import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import AzureRbacRoleDetails from './AzureRbacRoleDetails'
import { catalogDetailsDrawerExplainProps } from '../../catalogDetailsDrawerExplain'

const AzureRbacRolesDrawer = ({ id, toggleDrawer, attributes }) => {
    const isSmallScreen = useIsSmallScreen()
    const [targetPerson] = useTargetPerson()

    const { data: azureRbacRole } = useAzureRole(id, targetPerson?.id)

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <Box {...catalogDetailsDrawerExplainProps('Azure RBAC role')}>
                <ItemHeader title={azureRbacRole?.friendlyName} />
                {!azureRbacRole && <Loader />}
                {azureRbacRole && (
                    <AzureRbacRoleDetails
                        toggleDrawer={toggleDrawer}
                        attributes={attributes}
                        azureRbacRole={azureRbacRole}
                    />
                )}
            </Box>
        </ItemsDetailsMobileWrapper>
    ) : (
        <Drawer
            width="clamp(67%, 1007px, 90%)"
            open={!isNilOrEmpty(id)}
            toggleDrawer={toggleDrawer}
            stickyHeader
            header={<ItemHeader title={azureRbacRole?.friendlyName} />}
            closeOnOutsideClick
        >
            <Box {...catalogDetailsDrawerExplainProps('Azure RBAC role')}>
                {!azureRbacRole && <Loader />}
                {azureRbacRole && (
                    <AzureRbacRoleDetails
                        toggleDrawer={toggleDrawer}
                        attributes={attributes}
                        azureRbacRole={azureRbacRole}
                    />
                )}
            </Box>
        </Drawer>
    )
}

export default AzureRbacRolesDrawer
